import { CollectionListSection } from "../components/CollectionList";

const OrgCollection = () => {
  return (
    <div className="flex w-full" data-model-id="429:1752">
      <main className="flex-1 min-w-0">
        <CollectionListSection />
      </main>
    </div>
  );
};

export default OrgCollection;
